import React, { useEffect } from 'react';
import { Field } from 'formik';
import { Select, MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export enum ProcessingTypeEnum {
  Store = 1,
  Maker = 2,
  Tanking = 3
};

interface Props {
  processingType: number,
  meganetFrameMasterId: number,
  name: string,
  onChange: (processingType: number) => void,
}

const ProcessingTypeSelect: React.FC<Props> = ({ processingType: initialProcessingType, meganetFrameMasterId, name, onChange }) => {
  const {t} = useTranslation();

  const processingType = initialProcessingType || ProcessingTypeEnum.Store;
  const processingTypeEnum = Object.entries(ProcessingTypeEnum).filter(([key]) => { return isNaN(Number(key)) });

  useEffect(() => {
    if (!initialProcessingType) {
      onChange(processingType);
    }
  }, [initialProcessingType, onChange, processingType]);

  const handleSelectChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    onChange(event.target.value as number);
  };

  return (
    <Field
      style={{ fontSize: 13, maxWidth: 140 }}
      required
      fullWidth
      name={name}
      label="Processing"
      id={name}
      value={processingType}
      onChange={handleSelectChange}
      component={Select}
    >
      {
        processingTypeEnum.map(([key, value]) => (
          <MenuItem key={value} value={value}>
            <div style={{ whiteSpace: 'normal' }}>
              {t(key)}
            </div>
          </MenuItem>
        ))
      }
    </Field>
  );
};

export default ProcessingTypeSelect;